export enum MFACodeSentEnum {
  LOGIN = 'login',
  ACTIVATION = 'activation',
}
